/**
 * 角色常量登记表 —— 旧静态菜单树下线后，本文件只剩这一件事。
 *
 * 侧栏菜单由 `web/src/registry/features.ts`（Feature Registry）驱动、可见性判据在 `registry/access.ts`，
 * 路由守卫在 `App.tsx` 的 `roleRouteMap`；这里的常量是守卫 `roles` 字段与角色兜底判定的**唯一登记处**，
 * 被 `App.tsx` 与 `hooks/usePerm.ts` 消费，`scripts/lib/rbac-source.mjs` 也按文本解析它们（守卫 roles 字段）。
 * **不要在这里重建静态菜单树或菜单裁剪函数**：那会造出第二份菜单真源，与 Registry / menuTree.ts 漂移。
 */

/** 运营监控/现场管理可见角色：后端 monitor/* diag/* shift/* 均限 admin+supervisor */
export const MONITOR_ROLES = ['admin', 'supervisor'];

/** 运营配置面可见角色：机器人配置/在线客服机器人/知识库/话术库（后端已同步限 admin+supervisor） */
export const CONFIG_ROLES = ['admin', 'supervisor'];

/** 知识库分权角色码（40-RBAC 统一角色）：kb.admin 省级管理员 / kb.editor 省级采编 / kb.branch 分公司人员 */
export const KB_ROLES = ['kb.admin', 'kb.editor', 'kb.branch'];
